
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
}
